import { subdomainTypes } from "../../../context/availableSubdomains";

interface IProps {
  branch: subdomainTypes | "";
}

interface AgreementLink {
  label: string;
  href: string;
  isExternal?: boolean;
}

const AgreementLinks = ({ branch }: IProps) => {
  const links: AgreementLink[] = [
    {
      label: "Terms and Conditions",
      href: "https://cdn.fashionbiz.com/terms_and_conditions/Fashion+Biz+Australia+-+Terms+and+Coditions.pdf",
      isExternal: true,
    },
    {
      label: "Terms of Use",
      href: "https://cdn.fashionbiz.com/webstore_legal_docs/Fashion+Biz+Terms+of+Use+NZ.pdf",
      isExternal: true,
    },
    {
      label: "Privacy Policy",
      href: "https://cdn.fashionbiz.com/webstore_legal_docs/Private+Policy.pdf",
      isExternal: true,
    },
    {
      label: "Return Policy",
      href: "https://cdn.fashionbiz.com/webstore_legal_docs/RETURN+POLICY.pdf",
      isExternal: true,
    },
    {
      label: "Content Usage Agreement",
      href: "https://cdn.fashionbiz.com/Fashion+Biz+Content+Usage+Agreement.pdf",
      isExternal: true,
    },
  ];

  if (branch !== subdomainTypes.CA) {
    links.push({
      label: "Whistleblowing Portal",
      href: "https://www.whistleblowingservice.com.au/fashion-biz/",
      isExternal: true,
    });
  }

  if (branch === subdomainTypes.AU) {
    links.push({ label: "ISO Certification", href: "/iso-certification" });
  }

  return (
    <div className="agreement-links">
      <p className="agreement-links__intro">By using this webstore you agree to:</p>
      <div className="agreement-links__grid">
        {links.map((link) => {
          const isExternal = link.isExternal ?? link.href.startsWith("http");

          return (
            <a
              key={link.label}
              href={link.href}
              target={isExternal ? "_blank" : undefined}
              rel={isExternal ? "noopener noreferrer" : undefined}
            >
              {link.label}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default AgreementLinks;
